import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AddUserModal({ userRole, userId, onClose, onUserAdded }) {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
    role: 'employee',
    joining_date: new Date().toISOString().split('T')[0] // Default to today
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const token = localStorage.getItem('token');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const payload = {
        ...formData,
        manager_id: userRole === 'manager' ? userId : null,
        joining_date: new Date(formData.joining_date).toISOString()
      };

      const response = await axios.post(
        `${API}/users`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.data.success) {
        toast.success('User added successfully');
        onUserAdded();
        onClose();
      } else {
        toast.error(response.data.message || 'Failed to add user');
      }
    } catch (error) {
      console.error('Error adding user:', error);
      toast.error('Failed to add user');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose} data-testid="add-user-modal">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add New User</h2>
          <button className="close-btn" onClick={onClose} data-testid="close-modal-btn">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} data-testid="add-user-form">
          <div className="form-field">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              data-testid="user-name-input"
              value={formData.name}
              onChange={handleChange}
              placeholder="John Doe"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              data-testid="user-email-input"
              value={formData.email}
              onChange={handleChange}
              placeholder="john.doe@culinarycompass.in"
              required
            />
            <small style={{ color: '#718096', fontSize: '0.85rem' }}>
              Must end with @culinarycompass.in
            </small>
          </div>

          <div className="form-field">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              data-testid="user-password-input"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter password"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="joining_date">Joining Date</label>
            <input
              type="date"
              id="joining_date"
              name="joining_date"
              data-testid="user-joining-date-input"
              value={formData.joining_date}
              onChange={handleChange}
              required
            />
            <small style={{ color: '#718096', fontSize: '0.85rem' }}>
              Used to calculate earned leaves based on tenure
            </small>
          </div>

          {userRole === 'admin' && (
            <div className="form-field">
              <label htmlFor="role">Role</label>
              <select
                id="role"
                name="role"
                data-testid="user-role-select"
                value={formData.role}
                onChange={handleChange}
                required
              >
                <option value="employee">Employee</option>
                <option value="manager">Manager</option>
                <option value="admin">Admin</option>
              </select>
            </div>
          )}

          <button 
            type="submit" 
            className="submit-btn" 
            data-testid="submit-user-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Adding...' : 'Add User'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddUserModal;